/**
 * @description VRM Login route config
 */

(function() {
    'use strict';

    angular.module('vrm.core')
        .config(LoginRoute);

    /**
     * Configure Routing for Login State
     * @param $stateProvider
     * @constructor
     * @ngInject
     */
    function LoginRoute($stateProvider) {
        $stateProvider
            .state('login', {
                url: '/login?installationIdentifier?device?productId',
                views: {
                    "base": {
                        template: require('@/angular/views/core/login.html'),
                        controller: 'LoginController'
                    }
                },
                params: {
                    returnUrl: {
                        value: "base.installation-overview"
                    },
                    returnParams: {
                        value: null
                    },
                    invite: {
                        value: null
                    },
                    token: {
                        value: null
                    },
                    evt: {
                        value: null
                    }
                },
                data: {
                    skipLoginCheck: true,
                    sharedCanAccess:true,
                },
            })
            .state('login.invite', {
                url: '/invite/{invite:string}?type',
                data: {
                    skipLoginCheck: true,
                },
            })
            .state('login.verify_register', {
                url: '/evt/{evt:string}',
                data: {
                    skipLoginCheck: true,
                },
            })
            .state('login.change_email', {
                url: '/change/{emailHash:string}',
                data: {
                    skipLoginCheck: true,
                },
            })
            .state('login.verify_twofactor_reset', {
                url: '/verify-twofactor-reset/{twofactor_hash:string}',
                data: {
                    skipLoginCheck: true,
                },
            })
            .state('vc-login', {
                url: '/victron-connect-login',
                views: {
                    "base": {
                        template: require('@/angular/views/core/login-victron-connect.html'),
                        controller: 'LoginController'
                    }
                },
                params: {
                    victronConnect: true
                },
                data: {
                    skipLoginCheck: true,

                    sharedCanAccess: true
                },
            });
    }
})();

